<template>
    <div>
        <div class="echart" style="width: 100%;height: 500px;display: flex;flex-wrap: nowrap">
            <div :style="{height:height,width:width}" ref="myEchart"></div>
            <div :style="{height:height,width:width}" ref="myEchart2"></div>
        </div>
        <div class="echart" style="width: 80%;height: 400px;padding-bottom: 300px;margin-top: 30px">
            <div :style="{height:height}" ref="myEchart3" style="margin-left: 8%;width: 80%"></div>
        </div>
    </div>
</template>

<script>
import echarts from "echarts";

export default {
    data(){
        return{
          ageGroupData:[],
          genderData:[],
          arr:[],
          moneyArr:[],
          num:[],
          tuliarr:[]
        }
    },
  props: {
    // 设置图表的宽度
    width: {
      type: String,
      default: "50%"
    },
    // 设置图表的高度
    height: {
      type: String,
      default: "100%"
    },
    overflow: {
      //type:String,
      default: "hidden"
    }
  },
  mounted(){
    this.gender();          // 性别 数据
    this.ageGroup();         // 年龄段
    this.consumption();     // 消费金额
  },
    created(){

    },

    methods:{
        gender:function(){
            this.$axios({
                url: '/api/homepage/gender',
                method: 'GET'
            }).then(res => {
                console.log(res.data.data);
              let data = res.data.data;
              let arr2 = [];
              for (let k=0;k<data.length;k++){
                this.arr.push(data[k].name)
              }
              console.log(arr2);
              this.genderData=res.data.data;
              this.initChart();

            }).catch(err => {
                console.log(err);
            })
        },
        ageGroup:function(){
            this.$axios({
                url: '/api/homepage/age',
                method: 'GET'
            }).then(res => {
                console.log(res.data.data)
              let data = res.data.data;
                 let arr = [];
                for (let k=0;k<data.length;k++){
                  arr.push(data[k].name)
                }

              this.ageGroupData=res.data.data;
              this.tuliarr = arr;
              this.initChart(arr);
            }).catch(err => {
                console.log(err);
            })
        },
        consumption:function(){
            this.$axios({
                url: '/api/homepage/consume',
                method: 'GET'
            }).then(res => {
                console.log(res.data.data);
              let data = res.data.data;
              let moneyArr = [];
              let num = [];
              for (let i=0;i<data.length;i++){
                moneyArr.push(data[i].name);
                num.push(data[i].value);
              }
              this.moneyArr = moneyArr;
              this.num = num;
              this.initChart();
              console.log(this.num)
            }).catch(err => {
                console.log(err);
            })
        },
      initChart(e) {
        // console.log(  e)
        // 对图表进行初始化
        let chart = echarts.init(this.$refs.myEchart);
        let chart2 = echarts.init(this.$refs.myEchart2);
       // let chart3 = echarts.init(this.$refs.myEchart3);
        // 把配置和数据放这里
        chart.setOption({
          title : {
            text: '患者年龄段分布',
            x:'20%'
          },
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: 'vertical',
            right: '30%',
            bottom:'5%',
            data: this.tuliarr
          },
          series : [
            {
              name: '年龄数据',
              type: 'pie',
              radius : '60%',
              center: ['30%', '55%'],
              data: this.ageGroupData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]

        });
        chart2.setOption({
          title : {
            text: '患者男女比例分布',
            x:'25%'
          },
          tooltip : {
            trigger: 'item',
            formatter: "{a} <br/>{b} : {c} ({d}%)"
          },
          legend: {
            orient: 'vertical',
            right: '30%',
            bottom:'5%',
            data:  this.arr
          },
          series : [
            {
              name: '男女比例',
              type: 'pie',
              radius : '60%',
              center: ['30%', '55%'],
              data: this.genderData,
              itemStyle: {
                emphasis: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: 'rgba(0, 0, 0, 0.5)'
                }
              }
            }
          ]

        });
        /*chart3.setOption({
          title : {
            text: '消费资金分布',
            x:'center'
          },
          color: ['#3398DB'],
          tooltip : {
            trigger: 'axis',
            axisPointer : {            // 坐标轴指示器，坐标轴触发有效
              type : 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          xAxis : [
            {
              type : 'category',
              data : this.moneyArr,
              axisTick: {
                alignWithLabel: true
              }
            }
          ],
          yAxis : [
            {
              type : 'value'
            }
          ],
          series : [
            {
              name:'消费金额',
              type:'bar',
              barWidth: '40%',
              data:this.num,
              label: {
                normal: {
                  show: true,
                  position: 'top'
                }
              },
            },
          ]
        });*/
      }
    },

}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// dashboard.vue?679b6241